var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-date-picker", {
        staticStyle: { width: "100%" },
        attrs: {
          type: "year",
          placeholder: "选择年",
          "value-format": "yyyy",
          clearable: "",
        },
        on: { change: _vm.changeYear },
        model: {
          value: _vm.year,
          callback: function ($$v) {
            _vm.year = $$v
          },
          expression: "year",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }